import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useContext } from 'react';
import { StatusCardType } from '@/common/helios/OrderStatusCard';
import OrderState from '~/constants/common/OrderState';
import UserPurchaseContext from '~/context/home/UserPurchaseContext';
import ErrorBoundary from '~/utilities/ErrorBoundary';
import OrderStatusCard from './OrderStatusCard';

const EmptyFallback = () => null;

export default function OrderStatusCardMapper() {
  const { trackEvent } = useContext(AnalyticsContext);
  const {
    userPurchase: {
      hasError,
      data: { orderState, vehicle, openVerifications }
    }
  } = useContext(UserPurchaseContext);
  if (hasError) {
    trackEvent('Order Status Card Load Failed');

    return null;
  }

  let cardType: StatusCardType;

  switch (orderState) {
    case OrderState.OrderPlaced:
      cardType = StatusCardType.OrderPlaced;
      break;

    case OrderState.InProgress:
    case OrderState.InProgressWithTradeIn:
      cardType = StatusCardType.PurchaseInProgress;
      break;

    case OrderState.RecentlyPurchased:
      cardType = StatusCardType.Purchased;
      break;

    case OrderState.Reserved:
      cardType = StatusCardType.Reserved;
      break;

    default:
      return null;
  }

  return (
    <ErrorBoundary
      FallbackComponent={EmptyFallback}
      key={cardType}
      section={`Home OrderStatusCard - ${cardType}`}
    >
      <OrderStatusCard
        cardStatus={cardType}
        openVerifications={openVerifications}
        orderState={orderState}
        vehicle={vehicle}
      />
    </ErrorBoundary>
  );
}
